import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { CelebrationState } from '@ReactComponents/Shared/CelebrationState/CelebrationState';
export const SignUpWelcomeScreen = ({ activateCompany, bodyText }) => {
    return (_jsx(CelebrationState, { headerText: "Welcome to Emburse Spend", bodyText: bodyText !== null && bodyText !== void 0 ? bodyText : 'Thank you for submitting more information about your business. Your account has been successfully created and is ready to use. ', buttonText: "start using emburse spend", onClick: activateCompany }));
};
